/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title>评论列表
        <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回列表</span>
    </public-title>
    <div class="bg-white load-area">
      <el-tabs v-model="activeName" @tab-click="$GFUN.pageChange(1);getComments()" class="mb-3">
        <el-tab-pane :name="item.value" v-for="item in tabArr" :key="item.name">
          <label slot="label">{{item.name}}
            <span class="unread-msg" v-if="waitVerify.comment>0 && item.name==='待审核'">{{waitVerify.comment}}</span>
          </label>
        </el-tab-pane>
      </el-tabs>
      <p v-if="CommentLists.total<=0">当前没有数据</p>
      <div v-else>
        <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <div v-if="userInfo.type===99">
          <admin-itemize :Itemize="Itemize" v-for="Itemize in CommentLists.lists" :key="Itemize.id"/>
        </div>
        <div v-else>
          <store-itemize :Itemize="Itemize" :isComment = "isComment"
                         v-for="Itemize in CommentLists.lists" :key="Itemize.id"/>
        </div>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="CommentLists.total" :current-page="Number(queryCon.page)"
                       @current-change="$GFUN.pageChange"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations } from 'vuex'
  import AdminItemize from './AdminItemize'
  import StoreItemize from './StoreItemize'

  export default {
    name: 'StoreCommentLists',
    components: { AdminItemize,StoreItemize },
    computed: {
      ...mapState(['CommentLists','waitVerify']),
      ...mapGetters(['userInfo','isGroup','storeInfo']),
      queryCon() { return this.$route.query },
      tabArr() {
        switch (this.userInfo.type) {
          case 2:return [{name:'待评论',value:'0'},{name:'已评论',value:'1'}];
          case 3:
          case 5:
          case 6:
          case 8:
            return [{name:'待回复',value:'0'},{name:'已回复',value:'gt_0'}];
          case 99:return [{name:'待审核',value:'0'},{name:'已审核',value:'1'}];
          default:return [];
        }
      },
      titleArr() {
        switch (this.userInfo.type) {
          case 2:return ['订单编号','订单类型','操作'];
          case 3:
          case 5:
          case 6:
          case 8:return ['订单编号','评论时间','操作'];
          case 99:return ['订单主体','评论类型','评论/回复时间','操作'];
          default:return [];
        }
      },
      //是否为采购商待评论状态
      isComment() {
        return this.userInfo.type === 2 && this.activeName === '0'
      }
    },
    watch:{
      queryCon() { this.getComments(); },
    },
    data() {
      return {
        activeName:'0'
      }
    },
    mounted() {
      this.UPDATECURRENTSTORE({storeId:this.queryCon.store})
      this.getComments();
    },
    beforeDestroy() {
      this.UPDATECURRENTSTORE({storeId:''})
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getCommentLists']),
      //获取评论列表
      getComments() {
        let data = {};
        switch (this.userInfo.type) {
          case 99:
            data = {
              is_verify:this.activeName,
            }; break;
          case 2:
            data = {
              store_id:this.storeInfo.storeId,
              is_comment:this.activeName,
            }; break;
          default:
            data = {
              reply_store_id:this.storeInfo.storeId,
              reply_store_type:this.storeInfo.type,
              reply_time:this.activeName,
            }; break;
        }
        this.getCommentLists(data);
      }
    },
  }
</script>
<style lang="scss" scoped>
  .unread-msg{
    top: 5px;
    left: 48px;
  }
</style>
